import { render, staticRenderFns } from "./Gauge.vue?vue&type=template&id=87634010"
import script from "./Gauge.vue?vue&type=script&lang=js"
export * from "./Gauge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports